/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '../utils/functions.js';
import safeCustomStyle from '../utils/safeCustomStyle.js';
import { StyledI } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "disableFocusOutline", "customStyle"];
var I = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$disableFocusOutl = _ref.disableFocusOutline,
    disableFocusOutline = _ref$disableFocusOutl === undefined ? false : _ref$disableFocusOutl,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === undefined ? {
      elementStyle: {}
    } : _ref$customStyle,
    rest = _objectWithoutProperties(_ref, _excluded);
  var safeProps = safeRest(rest);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    elementStyle = _safeCustomStyle.elementStyle;
  return /*#__PURE__*/jsx(StyledI, _objectSpread(_objectSpread({
    ref: ref,
    elementStyle: elementStyle,
    disableFocusOutline: disableFocusOutline
  }, safeProps), {}, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? I.propTypes = {
  children: PropTypes.node.isRequired,
  disableFocusOutline: PropTypes.bool,
  customStyle: PropTypes.shape({
    elementStyle: PropTypes.object
  })
} : undefined;
process.env.NODE_ENV !== "production" ? I.displayName = 'I' : undefined;

export { I as default };
